module.exports = __webpack_public_path__ + "img/sc_back_default.788e398e.png";